import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
// import utils from '@/assets/js/utils.js';

Vue.use(Vuex)

export default new Vuex.Store({
    state:{
        userId:'',
        email:'',
        firstName:'',
        msg:'',
        showShare:true,
        errorCodeLink:{
            80930902:'activate',
            80930904:'complete',
            80930905:'failed',
            80930906:'activate',
            80931003:'complete',
            80931004:'failed',
            80931005:'complete',
            80930907:'regist',
            80930908:'failed',

        }
    },
    mutations: {
        setAccount (state, email) {
            state.email = email
        },
        setUserId (state, userId) {
            state.userId = userId
        }
    },
    plugins: [vuexLocal.plugin]
})
